"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const FileReviewStepPopup_1 = __importDefault(require("@Scenes/WorkScenes/Steps/FileReviewStep/FileReviewStepPopup"));
const FileReviewErrors_1 = __importDefault(require("@Scenes/WorkScenes/Steps/FileReviewStep/FileReviewErrors"));
const FileReviewCompletedWorks_1 = __importDefault(require("@Scenes/WorkScenes/Steps/FileReviewStep/FileReviewCompletedWorks"));
const file_review_expand_works_1 = require("@Scenes/WorkScenes/Steps/FileReviewStep/file-review-expand-works");
const limitItems = 10;
const FileReviewStep = () => {
    const { bulkUploadStore, workStore, rightsholderStore, uiStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [reviewCount, setReviewCount] = (0, react_1.useState)();
    const [currentPaginationPage, setCurrentPaginationPage] = (0, react_1.useState)(null);
    const [startTitlePosition, setStartTitlePosition] = (0, react_1.useState)();
    const [endTitlePosition, setEndTitlePosition] = (0, react_1.useState)();
    const [currentNumPage, setCurrentNumPage] = (0, react_1.useState)();
    const [readyWorksExpanded, setReadyWorksExpanded] = (0, react_1.useState)(false);
    const [errorWorksExpanded, setErrorWorksExpanded] = (0, react_1.useState)(true);
    const setTitlePositions = () => {
        const arrayWorks = bulkUploadStore.worksFromUpload;
        const startPosition = bulkUploadStore.startTitlePositionWorkSubmissions;
        if (!arrayWorks || !currentPaginationPage) {
            return;
        }
        if (currentNumPage && currentNumPage === currentPaginationPage.currentPage) {
            return;
        }
        if (!startTitlePosition || !endTitlePosition) {
            return;
        }
        const startOld = startTitlePosition;
        const endOld = endTitlePosition;
        const oldNumPage = currentNumPage;
        const countWorks = arrayWorks.error.length + arrayWorks.complete.length;
        let startNew;
        let endNew;
        if (oldNumPage) {
            if (currentPaginationPage.currentPage > oldNumPage) {
                startNew = endOld + 1;
                endNew = startNew + countWorks - 1;
            }
            else {
                endNew = startOld - 1;
                startNew = endNew - countWorks + 1;
            }
        }
        else {
            // for the first call
            // if start position is saved in the store
            startNew = startPosition ? startPosition : 1;
            endNew = startPosition ? startPosition + countWorks - 1 : countWorks;
        }
        setStartTitlePosition(startNew);
        setEndTitlePosition(endNew);
        setCurrentNumPage(currentPaginationPage.currentPage);
        bulkUploadStore.setStartTitlePositionWorkSubmissions(startNew);
    };
    const setCurrentPaginationPageFromBulkStore = () => {
        const paginationErrorWorks = bulkUploadStore.worksCompleteFromUploadPaginationInfo;
        const paginationCompleteWorks = bulkUploadStore.worksCompleteFromUploadPaginationInfo;
        const arrayWorks = bulkUploadStore.worksFromUpload;
        if (!arrayWorks) {
            return;
        }
        if (arrayWorks.completeCount <= limitItems && arrayWorks.errorCount <= limitItems) {
            setCurrentPaginationPage(null);
        }
        else {
            setCurrentPaginationPage(arrayWorks.completeCount > arrayWorks.errorCount ? paginationCompleteWorks : paginationErrorWorks);
        }
    };
    const setReviewCountFromBulkStore = () => {
        const arrayWorks = bulkUploadStore.worksFromUpload;
        if (!arrayWorks) {
            return;
        }
        setReviewCount(arrayWorks.completeCount + arrayWorks.errorCount);
    };
    const expandSection = (section) => {
        switch (section) {
            case file_review_expand_works_1.FileReviewExpandWorks.ready:
                setReadyWorksExpanded(true);
                break;
            case file_review_expand_works_1.FileReviewExpandWorks.error:
                setErrorWorksExpanded(true);
                break;
        }
    };
    const contractSection = (section) => {
        switch (section) {
            case file_review_expand_works_1.FileReviewExpandWorks.ready:
                setReadyWorksExpanded(false);
                break;
            case file_review_expand_works_1.FileReviewExpandWorks.error:
                setErrorWorksExpanded(false);
                break;
        }
    };
    (0, react_1.useEffect)(() => {
        setTitlePositions();
    });
    (0, react_1.useEffect)(() => {
        setCurrentPaginationPageFromBulkStore();
        setReviewCountFromBulkStore();
    }, []);
    const workDraftFromLocal = workStore.workDraftLocal;
    const currentRightsHolderId = rightsholderStore.currentRightsholderId;
    if (!workDraftFromLocal) {
        return null;
    }
    const arrayWorks = bulkUploadStore.worksFromUpload;
    const allArrayWorks = bulkUploadStore.allWorksFromUpload;
    if (!arrayWorks || !allArrayWorks) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: `/member/${currentRightsHolderId}/create-work/bulk` });
    }
    const numComplete = allArrayWorks.complete.length;
    const numErrors = allArrayWorks.error.length;
    const openModal = uiStore.bulkUploadModalIsOpen;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "head-create-work-wizard head-of-bulk" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("h2", null,
                    "Create Work: ",
                    react_1.default.createElement("span", null, "File Review"))),
            react_1.default.createElement("div", { className: "counter-wrapper" },
                react_1.default.createElement("p", { className: "invalid-count" },
                    "You have (",
                    numErrors,
                    ") works with an error"),
                react_1.default.createElement("p", { className: "valid-count" },
                    "You have (",
                    numComplete,
                    ") works without an error"))),
        react_1.default.createElement("div", { className: "file-review-step" },
            react_1.default.createElement("div", { className: "search-review-wrapper" },
                react_1.default.createElement("p", { className: "small bold" },
                    "Showing ",
                    reviewCount,
                    " files for review")),
            react_1.default.createElement("div", { className: "file-review-wrapper" },
                react_1.default.createElement("div", { className: "works-list-wrapper" },
                    arrayWorks.complete.length > 0 && (react_1.default.createElement(FileReviewCompletedWorks_1.default, { readyWorksExpanded: readyWorksExpanded, expandSection: expandSection, contractSection: contractSection, numComplete: numComplete, completedWorks: arrayWorks.complete })),
                    arrayWorks.error.length > 0 && (react_1.default.createElement(FileReviewErrors_1.default, { numErrors: numErrors, errorWorksExpanded: errorWorksExpanded, expandSection: expandSection, contractSection: contractSection, worksWithError: arrayWorks.error }))),
                react_1.default.createElement(ModalPortal_1.default, { isOpen: openModal, onClose: () => uiStore.setBulkUploadModalIsOpen(false) },
                    react_1.default.createElement(FileReviewStepPopup_1.default, { numComplete: numComplete, numErrors: numErrors }))))));
};
exports.default = (0, mobx_react_1.observer)(FileReviewStep);
